// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import reanimatedJS from './js-reanimated';
export default reanimatedJS;
